import { render, staticRenderFns } from "./_cabecalho.vue?vue&type=template&id=277683d8&scoped=true&"
import script from "./_cabecalho.vue?vue&type=script&lang=js&"
export * from "./_cabecalho.vue?vue&type=script&lang=js&"
import style0 from "./_cabecalho.vue?vue&type=style&index=0&id=277683d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277683d8",
  null
  
)

export default component.exports